/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DimAlberoDeliveryL3Dto interface.
 */
export function instanceOfDimAlberoDeliveryL3Dto(value) {
    return true;
}
export function DimAlberoDeliveryL3DtoFromJSON(json) {
    return DimAlberoDeliveryL3DtoFromJSONTyped(json, false);
}
export function DimAlberoDeliveryL3DtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'l3': json['l3'] == null ? undefined : json['l3'],
        'l3NomeStrutturaFunzione': json['l3NomeStrutturaFunzione'] == null ? undefined : json['l3NomeStrutturaFunzione'],
        'l3IdUtenteResp': json['l3IdUtenteResp'] == null ? undefined : json['l3IdUtenteResp'],
        'l3NominativoResp': json['l3NominativoResp'] == null ? undefined : json['l3NominativoResp'],
        'l3EmailResp': json['l3EmailResp'] == null ? undefined : json['l3EmailResp'],
    };
}
export function DimAlberoDeliveryL3DtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'l3': value['l3'],
        'l3NomeStrutturaFunzione': value['l3NomeStrutturaFunzione'],
        'l3IdUtenteResp': value['l3IdUtenteResp'],
        'l3NominativoResp': value['l3NominativoResp'],
        'l3EmailResp': value['l3EmailResp'],
    };
}
